export let weekDayDateFormat = "LmznS";
export default {weekDayDateFormat};